import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\ElectronicSignature\DownloadAuditDocumentElectronicSignatureController::__invoke
* @see app/Http/Controllers/ElectronicSignature/DownloadAuditDocumentElectronicSignatureController.php
* @route '/api/electronic-signature/download-audit-document/{electronicSignature}/{signer}'
*/
const DownloadAuditDocumentElectronicSignatureController = (args: { electronicSignature: string | number | { id: string | number }, signer: string | number | { id: string | number } } | [electronicSignature: string | number | { id: string | number }, signer: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: DownloadAuditDocumentElectronicSignatureController.url(args, options),
    method: 'post',
})

DownloadAuditDocumentElectronicSignatureController.definition = {
    methods: ["post"],
    url: '/api/electronic-signature/download-audit-document/{electronicSignature}/{signer}',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\ElectronicSignature\DownloadAuditDocumentElectronicSignatureController::__invoke
* @see app/Http/Controllers/ElectronicSignature/DownloadAuditDocumentElectronicSignatureController.php
* @route '/api/electronic-signature/download-audit-document/{electronicSignature}/{signer}'
*/
DownloadAuditDocumentElectronicSignatureController.url = (args: { electronicSignature: string | number | { id: string | number }, signer: string | number | { id: string | number } } | [electronicSignature: string | number | { id: string | number }, signer: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            electronicSignature: args[0],
            signer: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        electronicSignature: typeof args.electronicSignature === 'object'
        ? args.electronicSignature.id
        : args.electronicSignature,
        signer: typeof args.signer === 'object'
        ? args.signer.id
        : args.signer,
    }

    return DownloadAuditDocumentElectronicSignatureController.definition.url
            .replace('{electronicSignature}', parsedArgs.electronicSignature.toString())
            .replace('{signer}', parsedArgs.signer.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ElectronicSignature\DownloadAuditDocumentElectronicSignatureController::__invoke
* @see app/Http/Controllers/ElectronicSignature/DownloadAuditDocumentElectronicSignatureController.php
* @route '/api/electronic-signature/download-audit-document/{electronicSignature}/{signer}'
*/
DownloadAuditDocumentElectronicSignatureController.post = (args: { electronicSignature: string | number | { id: string | number }, signer: string | number | { id: string | number } } | [electronicSignature: string | number | { id: string | number }, signer: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: DownloadAuditDocumentElectronicSignatureController.url(args, options),
    method: 'post',
})

export default DownloadAuditDocumentElectronicSignatureController